import React, { useContext, useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';
import { useParams, useNavigate, useLocation } from 'react-router-dom';

import Loading from 'components/Loading/Loading';
import { COOKIE_CALLBACK_NUMBER } from 'constants/env';
import { useApi } from 'modules/Api/ApiContext';
import { AppContext } from 'store/AppContext';
import { fetchInitialData, getCookie } from 'utils/common/common';

function normalizeNumber(number = '') {
    return number
        .replace(/\D/g, '') // remove all non-digit characters
        .replace(/^1/, ''); // remove leading 1 (US country code)
}

function ProtectedRoute({ children }) {
    const { userData, setNewUserData, updateUserData } = useContext(AppContext);
    const [loading, setIsLoading] = useState(true);
    const callback_number = userData?.phoneNumber || '';
    const storedCBNumber = getCookie(COOKIE_CALLBACK_NUMBER);
    const navigate = useNavigate();
    const location = useLocation();
    const { fetchData } = useApi();
    const { t } = useTranslation();
    const { partnerId, requestId } = useParams();
    const isStatusPage = location.pathname.includes('/status');

    useEffect(() => {
        const normalizedCallback = normalizeNumber(callback_number);
        const normalizedStored = normalizeNumber(storedCBNumber || '');

        if (normalizedCallback !== normalizedStored && storedCBNumber) {
            setIsLoading(true);
            fetchInitialData({
                partnerId,
                requestId,
                setIsLoading,
                fetchData,
                updateUserData,
                setNewUserData,
                navigate,
                t,
                skipRedirect: isStatusPage,
            });
        } else if (!storedCBNumber) {
            setIsLoading(true);
            fetchInitialData({
                partnerId,
                requestId,
                setIsLoading,
                fetchData,
                updateUserData,
                setNewUserData,
                navigate,
                t,
                skipRedirect: isStatusPage,
            });
        } else {
            setIsLoading(false);
        }
    }, [
        storedCBNumber,
        callback_number,
        partnerId,
        requestId,
        location.pathname,
        fetchData,
        updateUserData,
        setNewUserData,
        navigate,
        t,
    ]);

    if (loading) {
        return <Loading />;
    }

    const normalizedCallback = normalizeNumber(callback_number);
    const normalizedStored = normalizeNumber(storedCBNumber || '');

    return normalizedCallback === normalizedStored ? children : <Loading />;
}

export default ProtectedRoute;
